const config = {
    nodeWidth:200,
    nodeHeight:30,
    portRadius:5,
}

const renderGroup = function (el, group, i) {
    let g = el.g()

    return g
}

const renderNode = function (el, node, i) {
    let width = config.nodeWidth;
    let height = config.nodeHeight;

    let rect = el.rect(0, 0, width, height, 10, 10).attr({ fill: Snap.mui.amber[300], stroke: Snap.mui.amber[600] });
    let g = el.g(rect).attr({ transform: `translate(0,${height * i})`, });
    return g;
}

const renderPort = function (el, port, portIndex, node, nodeIndex) {
    
    let cx ,cy;
    if(port.direction == "left"){
        cx = 0;
        cy = config.nodeHeight/2;
    }else if(port.direction == "right"){
        cx = config.nodeWidth;
        cy = config.nodeHeight/2;
    }else if(port.direction == "up"){
        cx = config.nodeWidth/2;
        cy = 0;
    }else{
        cx = config.nodeWidth/2;
        cy = config.nodeHeight;
    }
    let r = config.portRadius;
    let circle = el.circle(cx,cy,r).attr({fill:"green"})
    return circle;
}

export default {
    renderGroup, renderNode, renderPort
}


// WEBPACK FOOTER //
// ./src/assets/tflow/render/group/defaultRender.js